import { Component, OnInit } from '@angular/core';
import { ApsServiceService } from 'src/app/aps-service.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.css']
})
export class SubscriptionComponent implements OnInit {
  loaderdata:any=false
  issubscribe:any=localStorage.getItem('issubscribe')
  checksub:boolean=false
  getname:any=localStorage.getItem('FirstName') + " "+localStorage.getItem('LastName')
  userid:any = localStorage.getItem('userid');
  useremail:any=""
  Firstname:any=" "
  lastname:any=" "
  email:any=" "
  phone:any=" "
  address1:any=" "
  address2:any=" "
  zip:any=" "
  city:any=" "
  state:any=" "
  country:any=" "
  sub:any;
  getdatasub:any;
  rate_other:any='00';
  rate_usa:any='00';
  rate_canada:any='00';
  userdata:any;
  currentfull:any;
  checkpaymentstatus: any;

  // New veriable
  subpackage:any;

  

  form = new FormGroup({
    checkusa: new FormControl('',Validators.required),
    checkcanada: new FormControl('',Validators.required),
    checkother: new FormControl('',Validators.required),
    donationusa: new FormControl('',Validators.required),
    donationcanada: new FormControl('',Validators.required),
    donationother: new FormControl('',Validators.required),


   
  });
  get checkusa(): any { return this.form.get('checkusa'); }
  get checkcanada(): any { return this.form.get('checkcanada'); }
  get checkother(): any { return this.form.get('checkother');} 
  get donationusa(): any { return this.form.get('donationusa'); }
  get donationcanada(): any { return this.form.get('donationcanada'); }
  get donationother(): any { return this.form.get('donationother');} 


  clearInputMethod1() {  
     this.checkusa.reset();   this.checkcanada.reset(); this.checkother.reset(); 
     this.donationusa.reset(); this.donationcanada.reset(); this.donationother.reset();

   }





  constructor(private searchitem:ApsServiceService, private toastr: ToastrService,private activatedRoute: ActivatedRoute,private router: Router) { }

  ngOnInit(): void {

    if(this.issubscribe === 'false'){
      this.checksub=true
    }
    this.getsubdetails()

    this.getparams()
this.loaderdata=true
    this.searchitem.getLoginPackage().subscribe((returndata)=>{
      //console.log(returndata)
      this.getdatasub=returndata.plans
      //console.log( this.getdatasub[2]?.plan_validity)
      // this.loaderdata=false;
    });
    
  this.searchitem.getSub(this.userid).subscribe((responce) => {
    if(responce.status){
      this.sub=responce.data
    }
    this.loaderdata=false;
    


  })
  }


  getsubdetails=()=>{

    this.searchitem.getLoginsubPackage().subscribe((returndata)=>{
      // console.log(returndata);
      if(returndata.status){
      this.subpackage=returndata.datas
      }
    })

  }


  onChangescanada(data){
    //console.log(data)
    //console.log(data.split(" ")[0])
    this.rate_canada=data.split(" ")[0]
  
  }
  onChangesusa(data){
    //console.log(data)
    //console.log(data.split(" ")[0])
    this.rate_usa=data.split(" ")[0]
  
  }
  onChangesother(data){
    //console.log(data)
    //console.log(data.split(" ")[0])
    this.rate_other=data.split(" ")[0]
  
  }

  logout() {
    localStorage.clear();
    this.router.navigate(["/"]).then(() => {
      window.location.reload();
    });
  }

  onClickSubmitSub(datas){
    
    // console.log(datas)
    if(!datas['planname'] || datas['planname'] == " " ){
      this.toastr.error('Select Subscription Plan')
    }else{
if(datas['planname']==1){

  var rateitem=parseFloat(this.subpackage[0].usa)
  var selectedyears=1;
  var planname=this.subpackage[0].planname + " USA Membership";

}else if(datas['planname']==2){

  var rateitem=parseFloat(this.subpackage[0].canada)
  var selectedyears=1;
  var planname=this.subpackage[0].planname + " Canada / Mexico Membership";

}else if(datas['planname']==3){

  var rateitem=parseFloat(this.subpackage[0].other);
  var selectedyears=1;
  var planname=this.subpackage[0].planname + " Rest of World";
  
}else{
  this.toastr.error('Select Subscription Plan');
}

// console.log(rateitem)

// console.log(selectedyears)

// console.log(planname)
    this.loaderdata=true
    var userid=localStorage.getItem('userid')
    //console.log('reg');
    //console.log(datas['Canadaplanyear'].split(" ")[0])
   
  

    var donations=0
    this.userdata={}
    if(!datas['Donation'] ||datas['Donation'] == " " ){
      //console.log("null")
       donations=0;
    }else{
      //console.log("not null")
     donations= parseFloat(datas['Donation'])
    }
    this.userdata= {
      "userid":userid,
      "planyear":selectedyears,
      "planname":planname,
      "planamount":rateitem,
      "donations":donations
  
  }

  const myJSON = JSON.stringify(this.userdata);
localStorage.setItem("addsub",myJSON)
  //console.log(this.userdata)
var totalpayment=rateitem + donations

  var payloader=[]
  
  
  var dataset={}
  dataset["name"]=planname
  dataset["sku"]=1
  dataset["price"]= totalpayment
  dataset["currency"]="USD"
  dataset["quantity"]=1
  payloader.push(dataset)

var itemss=parseFloat(localStorage.getItem("totalCart"));
localStorage.setItem('storedcart',JSON.stringify(payloader))

var payments={
  "currency": "USD",
  "total": totalpayment
}

localStorage.setItem("totalsub",JSON.stringify(totalpayment))
//console.log(payments)
//   [{
//     "name": "Red Sox Hat",
//     "sku": "001",
//     "price": "5.00",
//     "currency": "USD",
//     "quantity": 1
// }]
//console.log(payloader)
  this.searchitem.subPayment(payments,payloader).subscribe((responce)=>{
  //console.log(responce.data)
  this.loaderdata=false
  window.location.href=responce.data;

  // this.routerItem.navigate([responce.data])
  

  })




  //   this.searchitem.subscription(this.userdata).subscribe((responce) => {
  // //console.log(responce);
  // if(responce.status){
  //   this.toastr.success('', 'Subscription Successfully Complected')
    
  // }else{
  //   this.toastr.error('error payment')

  // }
  //   })
  var listdataitem=localStorage.getItem("addsub")
  //console.log(listdataitem)

  }
}


  setUserPayment(){
    var planamount=localStorage.getItem('planamount');
    var planyear=localStorage.getItem('planyear');
    var planname=localStorage.getItem('planname');
    var userid=localStorage.getItem('userid');
    var donation=localStorage.getItem('Donation');
    var total=parseFloat(planamount) + parseFloat(donation)

    var payloader=[]
  
  
      var dataset={}
      dataset["name"]=planname
      dataset["sku"]=1
      dataset["price"]= total
      dataset["currency"]="USD"
      dataset["quantity"]=1
      payloader.push(dataset)
    
    var itemss=parseFloat(localStorage.getItem("totalCart"));
    localStorage.setItem('storedcart',JSON.stringify(payloader))
    
    var payments={
      "currency": "USD",
      "total": total
    }

    
    //console.log(payments)
    //   [{
    //     "name": "Red Sox Hat",
    //     "sku": "001",
    //     "price": "5.00",
    //     "currency": "USD",
    //     "quantity": 1
    // }]
    //console.log(payloader)
      this.searchitem.regPayment(payments,payloader).subscribe((responce)=>{
      //console.log(responce.data)
      this.loaderdata=false
      window.location.href=responce.data;
    
      // this.routerItem.navigate([responce.data])
      
    
      })
  }




  getparams(){
    if( this.activatedRoute.snapshot.params.payment){
    this.checkpaymentstatus = this.activatedRoute.snapshot.params.payment;
    //console.log(this.activatedRoute.snapshot.params)
    //console.log(this.checkpaymentstatus)
    var planamount=localStorage.getItem('planamount');
    var donation=localStorage.getItem('Donation');
    var total=parseFloat(planamount) + parseFloat(donation)
    if(this.checkpaymentstatus=="success"){
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      //console.log(params);
      
      var itemss=parseFloat(localStorage.getItem("totalsub"));
var payments={
  "currency": "USD",
  "total": itemss
}

this.searchitem.paymentSuccessreg(payments,params).subscribe((responce) => {
  if(responce.status){

    //console.log(responce)
   this.toastr.success("payment success")
    // this.addSubscription()
    this.logout()


}else{
  this.toastr.error('error payment')

}

})
      
    });



  }else     if(this.checkpaymentstatus=="cancel"){
    this.loaderdata=false;
    this.toastr.error('error payment')
  }
}


  }

  addSubscription(){

      this.searchitem.subscription(this.userdata).subscribe((responce) => {
  //console.log(responce);
  if(responce.status){
    this.toastr.success('', 'Subscription Successfully Complected')
    
  }else{
    this.toastr.error('error payment')

  }
    })
  }


  // new functions

  click_usa =()=>{
    this.checkcanada.reset(); 
    this.checkother.reset(); 
  }

  click_canada =()=>{
    this.checkusa.reset(); 
    this.checkother.reset(); 
  }
  click_other =()=>{

    this.checkusa.reset(); 
    this.checkcanada.reset(); 
  }

  onsubSubmit(){
    
  }







}
